import { render, staticRenderFns } from "./MicrositeBlanklayout.vue?vue&type=template&id=40f471f4"
import script from "./MicrositeBlanklayout.vue?vue&type=script&lang=js"
export * from "./MicrositeBlanklayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports